import {register} from "@/scripts/core/sections";

register('announcement-bar', {
    slider: null,

    onLoad() {
        this.init();
    },

    async init() {
        await Promise.all([
            this.initSlider(),
            this.initCloseButton(),
        ]);
    },

    async initCloseButton() {
        const container = this.container;
        if (!container) {
            return;
        }

        const closeButton = container.querySelector('[data-close-button]');
        if (!closeButton) {
            return;
        }

        closeButton.addEventListener('click', this.onClose.bind(this));
    },

    async onClose() {
        const container = this.container;
        if (!container) {
            return;
        }

        container?.classList?.add('hidden');

        try {
            await fetch(`${window.Shopify.routes.root || '/'}cart/update.js`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    attributes: {
                        _announcement_bar_closed: 1,
                    },
                }),
            }).then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            });
        } catch (error) {}
    },

    async initSlider() {
        const container = this.container;
        if (!container) {
            return;
        }

        const slider = container.querySelector('[data-slider]');
        if (!slider) {
            return;
        }

        try {
            const [
                { default: Swiper },
            ] = await Promise.all([
                import('swiper'),
            ]);

            this.slider = new Swiper(slider, {
                slidesPerView: 1,
            });
        } catch (error) {}
    },

    onUnload() {
        if (this.slider) {
            this.slider.destroy();
            this.slider = null;
        }
    },
});
